import axios from 'axios'
import { CONST_API_URL, CONST_API_JSON_URL } from '../constants'
import { soapEnvelopeAdding, soapEnvelopeRemoving } from './soapEnvelope'
import { checkLocalStorageSize } from '../util'
import { isTestingOn, isTestingOnFlag, isTestingOnFunc } from '../testingComponent/testingComponents'
import { getUserDetails } from '.'
import { performanceEmitter } from './performance/performanceMonitor';

const preLoginInstance = axios.create({ baseURL: CONST_API_URL })
preLoginInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
preLoginInstance.defaults.headers.common['mode'] = 'cors'
preLoginInstance.defaults.headers.common['CompanyId'] = getUserDetails?.CompanyId || ''
preLoginInstance.defaults.headers.common['UserId'] = getUserDetails?.UserId || ''
preLoginInstance.defaults.headers.post['Content-Type'] = 'text/xml'

const ApiPost = async (options) => {
  const { reqId, payload, resId, resType = 'object', getLatest = false, getFromLocal = true } = options
  
  // --- PHASE 1: PRE-PROCESS TIMING ---
  const startTimeTotal = Date.now();
  
  checkLocalStorageSize() 

  if (!getLatest && window.localStorage.logs && getFromLocal) {
    // Cache logic remains internal
  }

  const soapDataPayload = soapEnvelopeAdding(reqId, payload)
  const preTime = Date.now() - startTimeTotal;

  // --- PHASE 2: NETWORK TIMING ---
  const startTimeNet = Date.now();
  let axiosPost;
  try {
    axiosPost = await preLoginInstance.post('', soapDataPayload, { reqId, payload });
  } catch (err) {
    performanceEmitter.emit({
      label: reqId,
      elementId: payload?.insightsElementId || 'N/A',
      status: err.response?.status || 'FAIL',
      preTime,
      netTime: Date.now() - startTimeNet,
      postTime: 0,
      totalTime: Date.now() - startTimeTotal
    });
    throw err;
  }
  const netTime = Date.now() - startTimeNet; // This will match your 285ms Chrome time

  // --- PHASE 3: POST-PROCESS TIMING ---
  const onSuccess = async () => {
    const startTimePost = Date.now();
    const resp1 = axiosPost.request.response
    let resp2 = await soapEnvelopeRemoving(resId, resp1, resType)

    if (isTestingOnFlag()) {
      resp2 = isTestingOnFunc(reqId, resp2, payload)
    }

    // Storage Logic
    if (window.localStorage.getItem('logs') && getFromLocal) {
        if (reqId === 'GetStudies') {
            const oldData = JSON.parse(window.localStorage.getItem('GetStudies')) || []
            window.localStorage.setItem('GetStudies', JSON.stringify([{ reqId, payload, response: resp2 }, ...oldData]))
        } else if (reqId === 'GetProjects' || reqId === 'GetCompany') {
            window.localStorage.setItem(reqId, JSON.stringify([{ reqId, payload, response: resp2 }]))
        } else if (['GetStudyLayoutTabs', 'GetInsightsElementsForTab', 'GetInsightsElementHeading', 'GetInsightsElementInsights', 'GetBusinessObjectiveElement', 'GetRecommendationElement'].includes(reqId)) {
            // const oldData = JSON.parse(window.localStorage.getItem('GetSmallApiLogs')) || []
            // window.localStorage.setItem('GetSmallApiLogs', JSON.stringify([{ reqId, payload, response: resp2 }, ...oldData]))
        }
    }

    const postTime = Date.now() - startTimePost;
    const totalTime = Date.now() - startTimeTotal;

    performanceEmitter.emit({
      label: reqId,
      elementId: payload?.insightsElementId || 'N/A',
      status: axiosPost.status,
      preTime: preTime,    // Preparation time
      netTime: netTime,    // Actual network call
      postTime: postTime,  // XML parsing + Storage time
      totalTime: totalTime // Total user wait
    });

    checkLocalStorageSize()
    return resp2
  }

  return onSuccess();
}

const preLoginJsonInstance = axios.create({ baseURL: CONST_API_JSON_URL })
export { preLoginInstance, ApiPost, preLoginJsonInstance }